var _radialGradient, _path, _path2, _circle, _linearGradient, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "nw2JPvgEzDKQpjWgMaZM5a",
    cx: 48.477,
    cy: 36.475,
    r: 22.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd8af5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#b88bf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#a88ff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#8f96f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#6b9eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#3eaaec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29afea"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nw2JPvgEzDKQpjWgMaZM5a)",
    d: "M40,6H8C6.895,6,6,6.895,6,8v32c0,1.105,0.895,2,2,2h32c1.105,0,2-0.895,2-2V8 C42,6.895,41.105,6,40,6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#436dcd",
    d: "M32.065,23.065c-1.149-1.149-3.005-1.174-4.185-0.057L18,32.368V42h22c1.105,0,2-0.895,2-2v-7 L32.065,23.065z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 14.5,
    r: 3.5,
    fill: "#fff"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "nw2JPvgEzDKQpjWgMaZM5b",
    x1: 23.91,
    x2: 23.91,
    y1: 18.133,
    y2: 42.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#124787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#173b75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#173a73"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nw2JPvgEzDKQpjWgMaZM5b)",
    d: "M8,42h32c0.811,0,1.507-0.485,1.82-1.18L20.065,19.065c-1.149-1.149-3.005-1.174-4.185-0.057 L6,28.368V40C6,41.105,6.895,42,8,42z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotos);
export default __webpack_public_path__ + "static/media/photos.b6833e702d84fbde59889b733333b744.svg";
export { ForwardRef as ReactComponent };